import React from 'react';
import {
    Badge,
    Button,
    FormGroup,
} from 'reactstrap';
import moment from 'moment';
import { faUserClock } from '@fortawesome/free-solid-svg-icons';
import { httpClient } from '@s20/services/httpClient';
import { BaseFormViewModel } from '../common/ViewModel';
import SlideForm from '../common/forms/SlideForm';
import CommonContext, { ApiRoutes } from '../Common';
import {
    CollapseUnderlineHeader,
    Flex,
    FormLabel,
} from '../common/forms/FormElements';
import {
    BillingOTDays,
} from '../organization/Organization';

export default class BillingChargeEmployeeSlideout extends React.Component {
    static contextType = CommonContext;

    constructor(props) {
        super(props);

        this.formRef = React.createRef();

        const stateBase = {

            ...new BaseFormViewModel(),
        };

        this.state = stateBase;
    }

    onClose = () => {
        this.props.toggleShow(false);
        this.context.setFormOpened(false);
        this.props.onClose();
    };

    open = async (billingDetailId) => {
        // reset adjustments and validation on the way back in.
        this.props.toggleShow(true);
        this.setState({
            loading: true,
        });

        const [billperiods] = await Promise.all([
            httpClient.js(
                ApiRoutes.billingChargeCategory.billperiods(billingDetailId),
            ),
        ]);
        this.context.setFormOpened(true);
        this.setState({
            loading: false,
            billperiods,
        });
    };

    openInvoice = (invoiceId) => {
        this.props.toggleShow(false);
        this.props.onOpenInvoice(invoiceId);
    };

    openTimesheetDetails = (timesheetId) => {
        this.props.toggleShow(false);
        this.props.onOpenTimesheet(timesheetId);
    };

    render() {
        const {
            loading,
            billperiods,
        } = this.state;

        const showDoubleTime = !!this.context.tenant.tenantSettings.enableDoubleTimeBilling;
        const showPremiumTime = !!this.context.tenant.tenantSettings.enablePremiumBilling;
        const showShiftDifferential = !!this.context.tenant.tenantSettings.enableShiftDifferentialBilling;

        return (
            (!!billperiods
                && (
                    <SlideForm
                        size="col-xl-12 col-md-12 col-xs-12"
                        loading={loading}
                        show={this.props.show}
                        id="timesheetForm"
                        formIcon={faUserClock}
                        formTitle={`${billperiods.employeeName} - Week Of ${billperiods.weekOf}`}
                        ref={this.formRef}
                        className="pb-2 w-100"
                        readOnly={false}
                        onClose={this.onClose}
                        fullScreen
                    >
                        {
                            billperiods.companies.map((company) => {
                                const initialSelection = company.charges.find((x) => x.id == billperiods.id);
                                if (initialSelection !== undefined) {
                                    company.opened = true;
                                    billperiods.id = 0;
                                }

                                return (
                                    <CollapseUnderlineHeader
                                        key={company.id}
                                        className="mb-3"
                                        headerText={company.companyName}
                                        isOpen={company.opened}
                                        toggleCollapse={() => {
                                            company.opened = !company.opened;

                                            this.setState({
                                                billperiods,
                                            });
                                        }}
                                    >

                                        <div
                                            className="invoice-details"
                                            style={{ paddingTop: '4px', paddingBottom: '0px' }}
                                        >
                                            <Flex alignItems="center">
                                                <FormLabel
                                                    label="Overtime Days"
                                                />
                                                <span
                                                    className="text-muted ml-2"
                                                >
                                                    {company.otDays & BillingOTDays.Sunday ? 'Sunday' : ''}
                                                    {company.otDays & BillingOTDays.Monday ? ', Monday' : ''}
                                                    {company.otDays & BillingOTDays.Tuesday ? ', Tuesday' : ''}
                                                    {company.otDays & BillingOTDays.Wednesday ? ', Wednesday' : ''}
                                                    {company.otDays & BillingOTDays.Thursday ? ', Thursday' : ''}
                                                    {company.otDays & BillingOTDays.Friday ? ', Friday' : ''}
                                                    {company.otDays & BillingOTDays.Saturday ? ', Saturday' : ''}
                                                </span>
                                            </Flex>
                                            {company.useDailyOT && company.dailyOTThreshold > 0 && (
                                                <Flex alignItems="center">
                                                    <FormLabel
                                                        label="Daily Overtime"
                                                    />
                                                    <span
                                                        className="text-muted ml-2"
                                                    >
                                                        {company.dailyOTThreshold}
                                                        {' '}
                                                        hours
                                                    </span>
                                                </Flex>
                                            )}
                                            {company.otShiftStart != null && company.otShiftStart !== company.otShiftEnd && (
                                                <Flex alignItems="center">
                                                    <FormLabel
                                                        label="Overtime Shift"
                                                    />
                                                    <span
                                                        className="text-muted ml-2"
                                                    >
                                                        {moment(company.otShiftStart).format('h:mm A')}
                                                        {' '}
                                                        -
                                                        {moment(company.otShiftEnd).format('h:mm A')}
                                                    </span>
                                                </Flex>
                                            )}
                                            {company.otJobStart != null && company.otJobStart !== company.otJobEnd && (
                                                <Flex alignItems="center">
                                                    <FormLabel
                                                        label="Job Start Overtime"
                                                    />
                                                    <span
                                                        className="text-muted ml-2"
                                                    >

                                                        {moment(company.otJobStart).format('h:mm A')}
                                                        {' '}
                                                        -
                                                        {moment(company.otJobEnd).format('h:mm A')}
                                                    </span>
                                                </Flex>
                                            )}
                                        </div>

                                        <FormGroup>
                                            <FormLabel
                                                label="Week Charges"
                                            />

                                            <table className="table table-sm table-bordered table-striped timesheet-details-table">
                                                <thead className="text-muted">
                                                    <tr>
                                                        <th style={{ display: 'none' }} />
                                                        <th style={{ width: '165px' }}>Job Date</th>
                                                        <th>Timesheet</th>
                                                        <th>Dispatching</th>
                                                        <th>Charge</th>
                                                        <th>Job Start</th>
                                                        <th>Emp Start</th>
                                                        <th>Emp End</th>
                                                        <th style={{ textAlign: 'center', width: '50px' }}>Charge</th>
                                                        <th style={{ textAlign: 'center', width: '75px' }}>Bill</th>
                                                        <th style={{ textAlign: 'center', width: '50px' }}>Reg</th>

                                                        {showShiftDifferential && Boolean(company.companyHasShiftDifferentialBilling) && (
                                                            <th style={{ textAlign: 'center', width: '50px' }}>RSD</th>
                                                        )}

                                                        <th style={{ textAlign: 'center', width: '50px' }}>OT</th>

                                                        {showDoubleTime && Boolean(company.companyEnablesBillingDT) && (
                                                            <th style={{ textAlign: 'center', width: '50px' }}>DT</th>
                                                        )}

                                                        {showPremiumTime && (
                                                            <>
                                                                <th style={{ textAlign: 'center', width: '50px' }}>PR</th>
                                                                <th style={{ textAlign: 'center', width: '50px' }}>PROT</th>
                                                            </>
                                                        )}

                                                        <th style={{ textAlign: 'center', width: '75px' }}>Cancel</th>
                                                        <th style={{ textAlign: 'right', width: '75px' }}>MinMax Bill</th>
                                                        <th>Processed By</th>
                                                        <th>Process Date</th>
                                                        <th>Billing Status</th>
                                                        <th>Invoice</th>
                                                        <th style={{ display: 'none' }} />
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        company.charges.map((charge) => (
                                                            <tr
                                                                key={charge.id}
                                                                className={`timesheet-details-table-row${charge.current == 0 ? ' strikeout' : ''}`}
                                                            >
                                                                <td style={{ display: 'none' }} />
                                                                <td title={charge.id}>{moment(charge.jobDate).format('ddd M/D/YYYY')}</td>
                                                                <td>
                                                                    <Button
                                                                        color="link"
                                                                        className="site-link"
                                                                        title="Open Timesheet"
                                                                        onClick={() => {
                                                                            this.openTimesheetDetails(charge.timesheetId);
                                                                        }}
                                                                    >
                                                                        {charge.timesheetNumber}
                                                                    </Button>
                                                                </td>
                                                                <td>{charge.dispatchLocation}</td>
                                                                <td>{charge.chargeName}</td>
                                                                <td title={charge.jobStart != null ? moment(charge.jobStart).format('M/D/YYYY h:mm A') : '---'}>{charge.jobStart != null ? moment(charge.jobStart).format('h:mm A') : '---'}</td>
                                                                <td title={charge.startTime != null ? moment(charge.startTime).format('M/D/YYYY h:mm A') : '---'}>{charge.startTime != null ? moment(charge.startTime).format('h:mm A') : '---'}</td>
                                                                <td title={charge.endTime != null ? moment(charge.endTime).format('M/D/YYYY h:mm A') : '---'}>{charge.endTime != null ? moment(charge.endTime).format('h:mm A') : '---'}</td>
                                                                <td style={{ textAlign: 'right' }}>{charge.value}</td>
                                                                <td style={{ textAlign: 'right' }}>
                                                                    {charge.bill}
                                                                    {charge.breakAmt > 0
                                                                        && (
                                                                            <Badge
                                                                                color="info"
                                                                                className="ml-2"
                                                                                style={{
                                                                                    fontSize: '1em',
                                                                                    marginTop: '-2px',
                                                                                    cursor: 'default',
                                                                                }}
                                                                                title={`Hours: ${charge.breakAmt}`}
                                                                            >
                                                                                B
                                                                            </Badge>
                                                                        )}
                                                                </td>
                                                                <td style={{ textAlign: 'right' }}>{charge.reg}</td>

                                                                {showShiftDifferential && Boolean(company.companyHasShiftDifferentialBilling) && (
                                                                    <td style={{ textAlign: 'right' }}>{charge.rsd}</td>
                                                                )}

                                                                <td style={{ textAlign: 'right' }}>{charge.ot}</td>

                                                                {showDoubleTime && Boolean(company.companyEnablesBillingDT) && (
                                                                    <td style={{ textAlign: 'right' }}>{charge.dt}</td>
                                                                )}

                                                                {showPremiumTime && (
                                                                    <>
                                                                        <td style={{ textAlign: 'right' }}>{charge.pr}</td>
                                                                        <td style={{ textAlign: 'right' }}>{charge.prot}</td>
                                                                    </>
                                                                )}

                                                                <td className="text-center">{charge.isMinCancel ? 'Yes' : 'No'}</td>
                                                                <td className="text-center">{charge.isMinMaxBill ? 'Yes' : 'No'}</td>
                                                                <td>{charge.processedBy}</td>
                                                                <td>
                                                                    {charge.processDate != null ? moment(charge.processDate).format('M/D/YYYY h:mm A') : ''}
                                                                    &nbsp;&nbsp;

                                                                    {charge.isOutOfOrder && charge.ot > 0
                                                                        && (
                                                                            <i
                                                                                style={{ color: 'red' }}
                                                                                className="fas fa-exclamation-circle"
                                                                                title="OT Charge was processed out of order"
                                                                            />
                                                                        )}

                                                                    {charge.isOutOfOrder && charge.ot == 0
                                                                        && (
                                                                            <i
                                                                                style={{ color: 'orange' }}
                                                                                className="fas fa-exclamation-triangle"
                                                                                title="Charge was processed out of order"
                                                                            />
                                                                        )}
                                                                </td>
                                                                <td>{charge.billingStatus}</td>
                                                                <td>
                                                                    <Button
                                                                        color="link"
                                                                        className="site-link"
                                                                        title="Open Invoice"
                                                                        onClick={() => {
                                                                            this.openInvoice(charge.invoiceId);
                                                                        }}
                                                                    >
                                                                        {charge.invoiceNumber}
                                                                    </Button>
                                                                </td>
                                                                <td style={{ display: 'none' }} />
                                                            </tr>
                                                        ))
                                                    }
                                                </tbody>
                                            </table>
                                        </FormGroup>

                                        <table>
                                            <tbody>
                                                <tr>
                                                    <td>
                                                        <FormGroup>
                                                            <FormLabel
                                                                label="Charged Hours"
                                                            />

                                                            <table
                                                                className="table table-sm table-bordered table-striped adjustment-table"
                                                                style={{ width: '150px' }}
                                                            >
                                                                <thead className="text-muted">
                                                                    <tr>
                                                                        <th style={{ textAlign: 'center', minWidth: '75px' }}>Hours</th>
                                                                        <th style={{ textAlign: 'center', minWidth: '75px' }}>Breaks</th>

                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr>
                                                                        <td className="text-center">{company.totalHours}</td>
                                                                        <td className="text-center">{company.breakHours}</td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </FormGroup>
                                                    </td>

                                                    <td>
                                                        <div style={{ width: '10px' }}>&nbsp;</div>
                                                    </td>

                                                    <td>
                                                        <FormGroup>
                                                            <FormLabel
                                                                label="Processed Hours"
                                                            />

                                                            <table
                                                                className="table table-sm table-bordered table-striped adjustment-table"
                                                                style={{ width: '225px' }}
                                                            >
                                                                <thead className="text-muted">
                                                                    <tr>
                                                                        <th style={{ textAlign: 'center', minWidth: '75px' }}>Hours</th>
                                                                        <th style={{ textAlign: 'center', minWidth: '75px' }}>Regular</th>
                                                                        <th style={{ textAlign: 'center', minWidth: '75px' }}>OT</th>

                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr>
                                                                        <td className="text-center">{company.totalHours - company.breakHours}</td>
                                                                        <td className="text-center">{company.regularHours}</td>
                                                                        <td className="text-center">{company.totalHours - (company.regularHours + company.breakHours)}</td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </FormGroup>
                                                    </td>

                                                    {/* {company.useDailyOT && company.dailyOTThreshold > 0 && */}
                                                    {/*    <> */}
                                                    {/*        <td><div style={{ width: '10px' }}>&nbsp;</div></td> */}
                                                    {/*        <td> */}
                                                    {/*            <FormGroup style={{ marginTop: '-15px' }}> */}
                                                    {/*                <FormLabel */}
                                                    {/*                    label="(Daily OT)" */}
                                                    {/*                /> */}

                                                    {/*                <table className="table table-sm table-bordered table-striped adjustment-table" style={{ width: '200px'}}> */}
                                                    {/*                    <thead className="text-muted"> */}
                                                    {/*                        <tr> */}
                                                    {/*                            <th style={{ textAlign: 'center', minWidth: '75px' }}>Mon</th> */}
                                                    {/*                            <th style={{ textAlign: 'center', minWidth: '75px' }}>Tue</th> */}
                                                    {/*                            <th style={{ textAlign: 'center', minWidth: '75px' }}>Wed</th> */}
                                                    {/*                            <th style={{ textAlign: 'center', minWidth: '75px' }}>Thu</th> */}
                                                    {/*                            <th style={{ textAlign: 'center', minWidth: '75px' }}>Fri</th> */}
                                                    {/*                            <th style={{ textAlign: 'center', minWidth: '75px' }}>Sat</th> */}
                                                    {/*                            <th style={{ textAlign: 'center', minWidth: '75px' }}>Sun</th> */}
                                                    {/*                        </tr> */}
                                                    {/*                    </thead> */}
                                                    {/*                    <tbody> */}
                                                    {/*                        <tr> */}
                                                    {/*                            <td className="text-center">{company.dailyOTReg_Mon}</td> */}
                                                    {/*                            <td className="text-center">{company.dailyOTReg_Tue}</td> */}
                                                    {/*                            <td className="text-center">{company.dailyOTReg_Wed}</td> */}
                                                    {/*                            <td className="text-center">{company.dailyOTReg_Thu}</td> */}
                                                    {/*                            <td className="text-center">{company.dailyOTReg_Fri}</td> */}
                                                    {/*                            <td className="text-center">{company.dailyOTReg_Sat}</td> */}
                                                    {/*                            <td className="text-center">{company.dailyOTReg_Sun}</td> */}
                                                    {/*                        </tr> */}
                                                    {/*                    </tbody> */}
                                                    {/*                </table> */}
                                                    {/*            </FormGroup> */}
                                                    {/*        </td> */}
                                                    {/*    </> */}
                                                    {/* } */}
                                                </tr>
                                            </tbody>
                                        </table>

                                    </CollapseUnderlineHeader>
                                );
                            })
                        }

                    </SlideForm>
                )

            )

        );
    }
}
